import React from "react";
import {
  ResponsiveContainer,
  Radar,
  Tooltip,
  RadarChart,
  PolarGrid,
  Legend,
  PolarAngleAxis,
  PolarRadiusAxis
} from "recharts";

const intl = {
  own: {
    en: "Own evaluation",
    dk: "Egen evaluering"
  },
  peer1: {
    en: "Peer 1",
    dk: "Besvarelse 1"
  },
  peer2: {
    en: "Peer 2",
    dk: "Besvarelse 2"
  },
  peer3: {
    en: "Peer 3",
    dk: "Besvarelse 3"
  }
};

function CustomTooltip(prop1, prop2) {
  return (
    <div style={{ backgroundColor: "#fff", padding: "20px", color: "#000" }}>
      <div style={{ fontSize: "16px", marginBottom: "10px" }}>
        {prop1.label}
      </div>
      {prop1.payload &&
        prop1.payload.map(item => (
          <div style={{ textAlign: "left" }}>
            <div
              style={{
                display: "inline-block",
                backgroundColor: item.color,
                height: "10px",
                width: "10px"
              }}
            />{" "}
            {item.name}
            {": "}
            {item.value}{" "}
          </div>
        ))}
    </div>
  );
}
function ResultChart({
  invert,
  data,
  highlight,
  language,
  peer1Name,
  peer2Name,
  peer3Name,
  chartHeight,
  disableAxisLine,
  disableTick,
  ownName,
  stroke_Color,
  tick_Color
}) {
  const stroke = invert ? "#000" : "#565656";
  const res = data ? data[0] : false;
  return (
    <div style={{ height: chartHeight || "700px" }}>
      <ResponsiveContainer>
        <RadarChart data={data}>
          <PolarGrid gridType="circle" stroke={stroke} />
          {res && !!res.own && (
            <Radar
              name={ownName || intl.own[language]}
              isAnimationActive={false}
              dataKey="own"
              stroke="#1abc9c"
              strokeWidth={"3"}
              strokeOpacity={1}
              fill="#1abc9c"
              fillOpacity={0}
            />
          )}
          {res && !!res.peer1 && (
            <Radar
              name={peer1Name || intl.peer1[language]}
              isAnimationActive={false}
              dataKey="peer1"
              stroke="#BFFC33"
              strokeWidth={"3"}
              strokeOpacity={1}
              fill="#BFFC33"
              fillOpacity={0}
            />
          )}
          {res && !!res.peer2 && (
            <Radar
              name={peer2Name || intl.peer2[language]}
              isAnimationActive={false}
              dataKey="peer2"
              stroke="#F9A528"
              strokeWidth={"3"}
              strokeOpacity={1}
              fill="#F9A528"
              fillOpacity={0}
            />
          )}
          {res && !!res.peer3 && (
            <Radar
              name={peer3Name || intl.peer3[language]}
              isAnimationActive={false}
              dataKey="peer3"
              stroke="#8961CC"
              strokeWidth={"3"}
              strokeOpacity={1}
              fill="#8961CC"
              fillOpacity={0}
            />
          )}
          <Legend />
          <Tooltip content={<CustomTooltip />} />
          <PolarAngleAxis dataKey="key" tick={{ fill: tick_Color }} cy={800} />
          <PolarRadiusAxis
            interval={0}
            axisLine={!disableAxisLine}
            tick={!disableTick}
            angle={90}
            tickCount={7}
            domain={[0, 6]}
            stroke={stroke_Color}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ResultChart;

ResultChart.defaultProps = {
  isAnimationActive: false,
  invert: false,
  highlight: "all",
  disableAxisLine: false,
  disableTick: false,
  res: false
};



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultChart.js